import * as React from 'react';

function SvgCarOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M2 10.182l2.147-5.009c.349-.815 1.24-1.355 2.234-1.355H17.62c.995 0 1.885.54 2.234 1.355L22 10.182m-20 0h20m-20 0v8.182m20-8.182v8.182m0 0H2m20 0v1.818h-1.5v-1.818m-18.5 0v1.818h1.5v-1.818H2zM5.637 14.726a.91.91 0 100-1.819.91.91 0 000 1.82zM18.364 14.726a.91.91 0 100-1.819.91.91 0 000 1.82z" })));
}

export default SvgCarOutline;
